module.exports = __webpack_public_path__ + "static/slider2-ec385a54e5c24c005e32e1cd4bb49c63.jpg";